import { render, staticRenderFns } from "./call-log.vue?vue&type=template&id=13bff226&scoped=true"
import script from "./call-log.vue?vue&type=script&lang=js"
export * from "./call-log.vue?vue&type=script&lang=js"
import style0 from "./call-log.vue?vue&type=style&index=0&id=13bff226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bff226",
  null
  
)

export default component.exports